import React from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMapEvents } from 'react-leaflet';

import Alert from '../../../../DesignSystem/Alert';
import Dialog from '../../../../DesignSystem/Dialog';
import { MapContainer, GeoJSON } from '../../../../Maps';
import Marker from '../../../../Maps/Marker';
import PostStatuses from '../../../../../Utils/Types/PostStatuses';

const StyledMapContainer = styled(MapContainer)(({ theme }: any) => ({
  width: '100%',
  height: 400,
  borderRadius: theme.shape.borderRadius * 2,
  marginBottom: 2,
  zIndex: 1,
}));

function MapsModal({
  open,
  setOpen,
  setValue,
  setInputValue,
  lat,
  lng,
  geojson,
  onClear,
  children,
  latName = 'created_on_lat',
  lngName = 'created_on_lng',
  name = 'location',
}: any) {
  const intl = useIntl();

  const handleMarkerCreate = ({ latlng }: any) => {
    setInputValue(null);
    setValue(name, null);
    setValue(latName, latlng.lat);
    setValue(lngName, latlng.lng);
  };

  function MapEventsHook() {
    useMapEvents({
      click: ({ latlng }: any) => {
        handleMarkerCreate({ latlng });
      },
    });

    return null;
  }

  const handleClose = () => {
    setOpen(false);
  };

  const dialogActions = (
    <>
      <Button
        onClick={onClear}
        color="primary"
        size="large"
        variant="outlined"
        disabled={!lat && !lng}
      >
        <FormattedMessage id="POST_FORM.LOCALISATION_MODAL_NEGATIVE_BUTTON" />
      </Button>

      <Button onClick={handleClose} color="primary" size="large" variant="contained" autoFocus>
        <FormattedMessage id="POST_FORM.LOCALISATION_MODAL_POSITIVE_BUTTON" />
      </Button>
    </>
  );

  return (
    <Dialog
      id="post-form-localisation-modal"
      open={open}
      onClose={handleClose}
      actions={dialogActions}
      title={intl.formatMessage({ id: 'POST_FORM.LOCALISATION_MODAL_TITLE' })}
      label={intl.formatMessage({ id: 'POST_FORM.LOCALISATION_MODAL_TITLE' })}
      disableGutters
      keepMounted
    >
      <Box sx={{ p: 3 }}>
        {children}

        <Box sx={{ my: 2 }}>
          <Alert severity="info">
            <FormattedMessage id="POST_FORM.LOCALISATION_MODAL_NOTICE_TEXT" />
          </Alert>
        </Box>

        <StyledMapContainer center={[lat, lng]} geojson={geojson} doubleClickZoom={false}>
          <MapEventsHook />
          {lat && lng && <Marker position={[lat, lng]} status={PostStatuses.TODO} draggable />}
          {geojson && <GeoJSON data={geojson} />}
        </StyledMapContainer>
      </Box>
    </Dialog>
  );
}

export default MapsModal;
